<template>
    <GroupAddTabAccount />
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue'
import { ref, onUnmounted, provide } from '@vue/composition-api'
import store from '@/store'
import groupsStoreModule from '../groupsStoreModule'
import GroupAddTabAccount from './GroupAddTabAccount.vue'

export default {
  components: { BTab, BTabs, BCard, BAlert, BLink, GroupAddTabAccount },
  setup() {
    const GROUP_APP_STORE_MODULE_NAME = 'groups'
    const countries = ref([])
    const provinces = ref([])
    const group = ref({
      name: '',
      status: '',
      email: '',
      telefono: '',
      telefono2: '',
      direccion: '',
      poblacion: '',
      codigo_postal: '',
      provincia: null,
      pais: null
    })

    provide('countries', countries)
    provide('provinces', provinces)
    provide('group', group)

    if (!store.hasModule(GROUP_APP_STORE_MODULE_NAME)) store.registerModule(GROUP_APP_STORE_MODULE_NAME, groupsStoreModule)
    onUnmounted(() => { if (store.hasModule(GROUP_APP_STORE_MODULE_NAME)) store.unregisterModule(GROUP_APP_STORE_MODULE_NAME) })

    store.dispatch('groups/createGroup').then(response => {
        countries.value = response.data.countries
        provinces.value = response.data.provinces
    })

    return {

    }
  },
}
</script>

<style>

</style>
